export default __webpack_public_path__ + "static/1352-4a5ff18f21ed5f09e2cd63f5b2086d72.gif";